import axiosV1 from "@/plugins/axios/configV1";

export default {
    getFooters(params = {}) {
        return axiosV1.get("notifs/email-newsletter-footers", { params });
    },
    getFooter(id) {
        return axiosV1.get(`notifs/email-newsletter-footers/${id}`);
    },
    createFooter(payload = {}) {
        return axiosV1.post("notifs/email-newsletter-footers", payload);
    },
    updateFooter(id, payload = {}) {
        return axiosV1.put(`notifs/email-newsletter-footers/${id}`, payload);
    },
    deleteFooter(id) {
        return axiosV1.post(`notifs/email-newsletter-footers/${id}`);
    },
    duplicateFooter(id) {
        return axiosV1.post(`notifs/email-newsletter-footers/${id}/duplicate`);
    },
    uploadFooterImage(formData) {
        return axiosV1.post("notifs/email-newsletter-footers/upload-image", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
    deleteFooterImage(path) {
        return axiosV1.post("notifs/email-newsletter-footers/delete-image", { path });
    },
};
